import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from '@auth0/auth0-angular';
import {HomeComponent} from './components/home/home.component';
import {WrapperProfileComponent} from './components/profile/wrapper-profile/wrapper-profile.component';
import {AuditComponent} from './components/system-logs/audit/audit.component';
import {PermissionsGuard} from './guards/permissions.guard';
import {UserRoles, roles} from './shared/utils/roles';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'employee',
        pathMatch: 'full',
      },
      {
        path: 'employee',
        loadChildren: () =>
          import('./components/employees/employees.module').then(
            m => m.EmployeesModule
          ),
        canActivate: [PermissionsGuard],
        data: {permission: roles.ALLOWED_ALL},
      },
      {
        path: 'interviews',
        pathMatch: 'full',
        loadChildren: () =>
          import('./components/interviews/interviews.module').then(
            m => m.InterviewsModule
          ),
        canActivate: [PermissionsGuard],
        data: {permission: []},
        // Temporary commented
        // data: {
        //   permission: [
        //     ...roles.HR_DEPARTMENT,
        //     ...roles.RECRUITMENT_DEPARTMENT,
        //     ...roles.CEO,
        //   ],
        // },
      },
      {
        path: 'profile',
        component: WrapperProfileComponent,
        loadChildren: () =>
          import('./components/profile/profile.module').then(
            m => m.ProfileModule
          ),
        canActivate: [PermissionsGuard],
        data: {permission: roles.ALLOWED_ALL},
      },
      {
        path: 'time-logs',
        // component: MainAnukoComponent will be here
        loadChildren: () =>
          import('./components/accountant/anuko-data/anuko-data.module').then(
            m => m.AnukoDataModule
          ),
        canActivate: [PermissionsGuard],
        data: {permission: [...roles.ACCOUNTANT_DEPARTMENT, ...roles.CEO]},
      },
      {
        path: 'salary',
        loadChildren: () =>
          import('./components/accountant/salary/salary.module').then(
            m => m.SalaryModule
          ),
        canActivate: [PermissionsGuard],
        data: {permission: [...roles.ACCOUNTANT_DEPARTMENT, ...roles.CEO]},
      },
      {
        path: 'system-logs',
        loadChildren: () =>
          import('./components/system-logs/system-logs.module').then(
            m => m.SystemLogsModule
          ),
        canActivate: [PermissionsGuard],
        data: {
          permission: [
            ...roles.ALL_DEPARTMENTS_HEADS,
            ...roles.DELIVERY_MANAGEMENT,
            ...roles.CEO,
          ],
        },
      },
      {
        path: 'notifications',
        loadComponent: () =>
          import(
            './components/approval-notification/approval-notification.component'
          ).then(m => m.ApprovalNotificationComponent),
        canActivate: [PermissionsGuard],
        data: {
          permission: [
            ...roles.HR_DEPARTMENT,
            ...roles.ACCOUNTANT_DEPARTMENT,
            ...roles.CEO,
            ...roles.DELIVERY_DEPARTMENT,
            ...roles.LINE_MANAGEMENT,
            ...roles.ADMIN,
          ],
        },
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./components/settings/settings.module').then(
            m => m.SettingsModule
          ),
        canActivate: [PermissionsGuard],
        data: {
          permission: [
            ...roles.CEO,
            ...roles.HR_DEPARTMENT,
            ...roles.ACCOUNTANT_DEPARTMENT,
            ...roles.DELIVERY_DEPARTMENT,
            UserRoles.headOfRecruitment,
            UserRoles.leadOfRecruitment,
          ],
        },
      },
      {
        path: 'audit',
        component: AuditComponent,
        canActivate: [PermissionsGuard],
        data: {permission: roles.ADMIN},
      },
      {
        path: 'events',
        loadChildren: () =>
          import('./components/events/events.module').then(m => m.EventsModule),
        canActivate: [PermissionsGuard],
        data: {permission: [...roles.CEO, ...roles.HR_DEPARTMENT]},
      },
      {
        path: 'roles',
        loadChildren: () =>
          import('./components/roles/roles.module').then(m => m.RolesModule),
        canActivate: [PermissionsGuard],
        data: {permission: [...roles.CEO, ...roles.ADMIN]},
      },
      {
        path: 'credits',
        loadChildren: () =>
          import('./components/credits/credits.module').then(
            m => m.CreditsModule
          ),
      },
      {
        path: 'bcoins',
        loadChildren: () =>
          import('./components/bcoins/bcoins.module').then(m => m.BcoinsModule),
        canActivate: [PermissionsGuard],
        data: {permission: [...roles.CEO, ...roles.HR_DEPARTMENT]},
      },
      {
        path: '**',
        redirectTo: 'employee',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
